const ZamanTipiEnum = {
    0: "Tam Zamanlı",
    1: "Yarı Zamanlı",
    2: "Freelance",
    '-1': "Belirtilmemiş",
};

export default ZamanTipiEnum;